import Utils from './Utils.js';
import Common from './Common.js';
import Navi from './Navigation.js';

class SwipeHelper {
    constructor(_option) {
        this.comm = Common.instance;
        this.navi = Navi.instance;

        this.startPoint = 0;
        this.moveStartDir = 0;
        this.option = {
            container: null,
            dragEl: null,
            direction: 'vertical', //'  horizontal'

            moveStartDir1: 8,
            moveStartDir2: 16,
            addEventType: 'swipeup swipedown'
        };

        $.extend(true, this.option, _option);

        if( this.option.direction == 'horizontal' ){
            this.option.moveStartDir1 = 2;
            this.option.moveStartDir2 = 4;
            this.option.addEventType = 'swipeleft swiperight';
        }

        this.mc = new Hammer(this.option.container[0]);
        this.mc.get('pan').set({ direction: Hammer.DIRECTION_ALL });
        this.mc.get('swipe').set({ direction: Hammer.DIRECTION_ALL });


        this.mc.on("panstart panmove panend pancancel " + this.option.addEventType, (ev) => {

            if (ev.type == 'panstart'){
                this.startPoint = this.option.direction == 'vertical'? ev.center.y: ev.center.x;
                this.moveStartDir = ev.direction;
            }

            if ( (this.moveStartDir == this.option.moveStartDir1 || this.moveStartDir == this.option.moveStartDir2) && ev.type == 'panmove'){
                let cssObj = {};
                    cssObj['transition-duration'] = '0ms';
                    cssObj[Utils.vPrefix + 'transform'] = this.dragContainer(ev.center);
                    cssObj['transform'] = this.dragContainer(ev.center);

                this.option.dragEl.css( cssObj );
            }

            if ((this.moveStartDir == this.option.moveStartDir1 || this.moveStartDir == this.option.moveStartDir2) && (ev.type == 'panend' || ev.type == 'pancancel') ){
                if(Utils.isPreventTime(this.lastWheelTime, 500)) return;
                this.navi.go(this.comm.depth.d1, this.comm.depth.d2);
            }

            if(this.option.direction == 'vertical'){
                if (ev.type == 'swipeup'){
                    this.lastWheelTime = new Date().getTime();
                    this.navi.updateDown();
                }
                if (ev.type == 'swipedown' ){
                    this.lastWheelTime = new Date().getTime();
                    this.navi.updateUp();
                }
            } else {
                if (ev.type == 'swiperight'){
                    this.lastWheelTime = new Date().getTime();
                    this.navi.updateLeft();
                }
                if (ev.type == 'swipeleft' ){
                    this.lastWheelTime = new Date().getTime();
                    this.navi.updateRight();
                }
            }
        });
    }

    dragContainer(_cexter){
        let yPos = 0;
        let xPos = 0;
        let dist = 0;
        if(this.option.direction == 'vertical'){
            yPos = -( this.comm.mainContainer[0].clientHeight * (this.comm.depth.d1-1) );
            dist = _cexter.y - this.startPoint;
            return `translate(0px, ${yPos+dist}px)`;
        }else if(this.option.direction == 'horizontal'){
            xPos = -( this.comm.mainContainer[0].clientWidth * (this.comm.depth.d2-1) );
            dist = _cexter.x - this.startPoint;
            return `translate(${xPos+dist}px, 0px)`;
        }
    }

}

export default SwipeHelper;


// WEBPACK FOOTER //
// ./SwipeHelper.js